<template>
    <div class="feedback">
        <app-header @on-click="goBack" :title="$t('feedback.title')" backgroundColor="#f2f2f2" />
        <div class="feedback-questions">
            <div class="questionList">
                <div v-for="question in questionsList" :key="question.key" class="question-item">
                    <div class="question-title">
                        {{question.question}}
                    </div>
                    <!-- <div v-for="answer in question.answers" class="answers" :key="answer.value">
                          {{answer.label}}
                    </div> -->
                    <!-- <van-radio-group v-model="formData[question.key]" v-if="question.type === 'radio'">
                        <van-radio class="answers" :name="answer.value" v-for="answer in question.answers" :key="answer.value">{{answer.label}}</van-radio>
                    </van-radio-group> -->
                    <van-checkbox-group v-model="formData[question.key]" @change="checkboxChange($event,question)">
                        <van-checkbox class="answers" :shape="question.type === 'checkbox' ? 'square' : 'round'" :name="answer.value" v-for="answer in question.answers" :key="answer.value">{{answer.label}}</van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <div class="other-opinions" v-if="questionsList && questionsList.length">{{$t('feedback.other_opinions')}}</div>
            <div class="feedback-content" :class="questionsList && questionsList.length ? 'pt5' : ''" @touchstart="handleForceFocus('feedbackInput')">
                <van-field
                    @touchstart="handleForceFocus('feedbackInput')"
                    ref="feedbackInput"
                    class="feedback-textarea"
                    v-model.trim="value"
                    rows="7"
                    autosize
                    type="textarea"
                    clearable
                    :placeholder="$t('feedback.placeholder')"
                    maxlength="330"
                    show-word-limit
                />
            </div>
            <div class="feedback-footer">
                <van-button class="submit-btn" :disabled="isDisabled" @click="onSubmit()" block type="info">{{ $t('feedback.submit') }}</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Checkbox, CheckboxGroup, RadioGroup, Radio  } from 'vant';
import AppAndtips from '@/data/appAndtips.js';
import { deepClone } from "@/utils/util";
export default {
    name: "Feedback",
    data() {
        return {
            value: '',
            feedbackData: {
                // 'CN': {
                //     'zh-CN': [
                //         {
                //             question: '您对当前流量兑换流程的满意度如何？',
                //             key: "q1",
                //             type: "radio",
                //             answers: [
                //                 {
                //                 label: '非常满意（流程顺畅）',
                //                 value: 5,
                //                 parentKey: 'q1'
                //                 },
                //                 {
                //                 label: '比较满意（有小问题但不影响）',
                //                 value: 4,
                //                 parentKey: 'q1'
                //                 },
                //                 {
                //                 label: '一般（操作略复杂）',
                //                 value: 3,
                //                 parentKey: 'q1'
                //                 },
                //             ]
                //         },
                //         {
                //         question: '您最希望商城新增哪项功能？',
                //         key: "q2",
                //         type: "checkbox",
                //         answers: [
                //             {
                //             label: '一键续订流量包',
                //             value: 5,
                //             parentKey: 'q2'
                //             },
                //             {
                //             label: '个性化套餐推荐',
                //             value: 4,
                //             parentKey: 'q2'
                //             },
                //             {
                //             label: '实时流量使用提醒',
                //             value: 3,
                //             parentKey: 'q2'
                //             },
                //         ]
                //         },
                //     ],
                // },
                // useOneData: {
                //     US:'CN'
                // }
            },
            questionsList: [],
            formData: {},
            resetFormData: {},
        };
    },
    components:{
        vanCheckbox:Checkbox, 
        vanCheckboxGroup:CheckboxGroup, 
        vanRadioGroup:RadioGroup, 
        vanRadio:Radio
    },
    computed: {
        isDisabled() {
            for (let key in this.formData) {
                if (this.formData[key].length > 0) {
                    return false;
                }
            }
            return this.value.trim().length === 0;
        }
    },
    mounted(){
        this.getFeedbackData();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },  
        // 获取反馈内容
        getFeedbackData() {
            AppAndtips.getConfig('appTips-config.json').then(d => {
                if(d.feedbackData){
                    this.feedbackData = d.feedbackData;
                    this.getFeedbackQuestions();
                }
            })
        },
        // 输入框获取焦点
        handleForceFocus(ref) {
            setTimeout(() => {
                this.$refs[ref]?.focus();
            }, 200);
        },
        // 获取反馈问题列表
        getFeedbackQuestions() {
            let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
            let countryCode = urlData.registerCountry || urlData.placeCode;
            let language = this.$i18n.locale || 'zh-CN';
            if(!this.feedbackData[countryCode] && this.feedbackData.useOneData){
                let country = this.feedbackData.useOneData[countryCode];
                if(country) countryCode = country;
            }
            let questions = (this.feedbackData[countryCode] && this.feedbackData[countryCode][language]) || [];
            this.questionsList = questions;
            this.questionsList.forEach(item => {
                this.$set(this.formData, item.key, []);
            })
            this.resetFormData = deepClone(this.formData);
        },
        // 
        checkboxChange(e,question){
            if(question.type === 'radio' && e.length > 1){
                // 单选类型只保留单个值
                this.formData[question.key] = [e[e.length -1]];
            }
        },
        // 提交反馈
        onSubmit() {
            let queryList = [];
            let quesAndAns = {};
            for (const key in this.formData) {
                const element = this.formData[key];
                if(element && element.length){
                    queryList.push(key);
                    let question = this.questionsList.find(item => item.key === key);
                    quesAndAns['fb_q_' + key] = question.question;
                    element.forEach((ans, index) => {
                        let answerObj = (question.answers||[]).find(item => item.value === ans);
                        quesAndAns['fb_a_' + key + '_' + answerObj.value] = answerObj.label;
                    });
                }
            }
            let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
            let params = {
                feedback_account: urlData.username,
                feedback_imei: urlData.imei,
            }
            if(queryList && queryList.length){
                params = {
                    ...params,
                    feedback_questions: queryList.join(','),
                    feedback_answers: JSON.stringify(this.formData),
                    ...quesAndAns,
                }
            }
            if(this.value.trim()){
                params = {
                    ...params,
                    feedback_content: this.value.trim(),
                }
            }
            // 神策-上报用户反馈意见
            this.$sensors.track('WebUserFeedback', params,  () => {
                    this.value = '';
                    this.formData = deepClone(this.resetFormData);
                    this.$toast(this.$t('feedback.submit_success'));
                });
        },
    },
}
</script>

<style lang="less" scoped>
.feedback {
    background-color: #f2f2f2;
    min-height: 100vh;
    ::v-deep {
        .header {
            font-weight: 600;
            .title {
                font-size: 15px;
            }
        }
    }
    .feedback-questions {
        padding: 12px;
    }
    .questionList {
        font-size: 14px;
        background-color: #fff;
        overflow: hidden;
        padding: 0 10px;
        border-radius: 12px;
        .question-item {
            margin: 8px 0;
            .question-title {
                font-weight: 600;
                font-size: 15px;
            }
            .answers {
                border-radius: 4px;
                min-height: 30px;
                margin: 8px 5px;
                padding: 2px 4px;
                display: flex;
                align-items: center;
            }
            .active {
                color: #4361ee;
                // background-color: #4361ee;
            }
        }
    }
    .other-opinions {
        margin: 12px 0 0 0;
        font-size: 14px;
        font-weight: 600;
    }
    .feedback-content {
        // padding: 12px;
        padding: 12px 0;
        .feedback-textarea {
            background-color: #fff;
            min-height: 200px;
            max-height: 400px;
            overflow-y: auto;
            border-radius: 12px;
            font-size: 14px;
        }
    }
    .pt5 {
        padding-top: 5px;
    }
    .feedback-footer {
        position: sticky;
        bottom: 0;
        // padding: 12px;
        .submit-btn {
            background-color: #4361ee;
            border-radius: 8px;
            width: 100%;
            height: 50px;
            font-size: 16px;
        }
        ::v-deep {
            .van-button--disabled {
                opacity: 1;
                background-color: #9aa9f0;
                border-color: #9aa9f0;
            }
        }
    }
}
html[dir="rtl"] .feedback {
    ::v-deep {
        .van-field__control {
            text-align: right;
        }
        .van-field__left-icon {
            margin-right: unset;
            margin-left: 0.111111rem;
        }
        .van-field__word-limit {
            text-align: left;
        }
        .van-checkbox__label {
            margin-left: unset;
            margin-right: 8px;
        }
    }
}
</style>